import { useMemo } from "react";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { PickersPtBr } from "./PickersPtBr";
import { textFieldDoCampo, type CampoPickerProps } from "./campoPicker";

const DATA = /^\d{4}-\d{2}-\d{2}$/;

// Data "AAAA-MM-DD" mostrada em DD/MM/AAAA, com o calendário do MUI em pt-br. O
// <input type="date"> nativo segue o idioma do navegador: o Chrome em inglês mostra MM/DD/AAAA.
// Data incompleta chega como "".
export function DataField(props: CampoPickerProps) {
  const { label, value, onChange, disabled } = props;
  const data = useMemo(() => {
    const d = DATA.test(value) ? dayjs(value) : null;
    return d?.isValid() ? d : null;
  }, [value]);
  return (
    <PickersPtBr>
      <DatePicker
        label={label}
        value={data}
        disabled={disabled}
        onChange={(d) => onChange(d?.isValid() ? d.format("YYYY-MM-DD") : "")}
        slotProps={{ textField: textFieldDoCampo(props) }}
      />
    </PickersPtBr>
  );
}
